import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  _baseURL: string = "api/Color";

  constructor(private http: HttpClient) { }

  getAllColors() {
    return this.http.get<Color[]>(this._baseURL + "/GetAll");
  }
}
